export class CustomLoading extends pc.ScriptType {

	initialize() {
		this.createCss();
		this.app.on('loading', this.showSplash);
		this.app.on('finishedLoading', this.hideSplash);
		this.app.on('loading:progress', this.setProgress);
	}

	showSplash() {
		// splash wrapper
		var wrapper = document.createElement('div');
		wrapper.id = 'application-splash-wrapper';
		document.body.appendChild(wrapper);

		// splash
		var splash = document.createElement('div');
		splash.id = 'application-splash';
		wrapper.appendChild(splash);
		splash.style.display = 'none';

		var logo = document.createElement('img');
		logo.src = './assets/transparent_logo.png';
		splash.appendChild(logo);
		logo.onload = function () {
			splash.style.display = 'block';
		};

		var container = document.createElement('div');
		container.id = 'progress-bar-container';
		splash.appendChild(container);

		var bar = document.createElement('div');
		bar.id = 'progress-bar';
		container.appendChild(bar);
	}

	hideSplash() {
		var splash = document.getElementById('application-splash-wrapper');
		splash.parentElement.removeChild(splash);
	}

	setProgress(value) {
		var bar = document.getElementById('progress-bar');
		if(bar) {
			value = Math.min(1, Math.max(0, value));
			bar.style.width = value * 100 + '%';
		}
	}

	createCss() {
		var css = [
			'body {',
			'    background-color: #FFFFFF;',
			'}',

			'#application-splash-wrapper {',
			'    position: absolute;',
			'    top: 0;',
			'    left: 0;',
			'    height: 100%;',
			'    width: 100%;',
			'    background-color: #FFFFFF;',
			'}',

			'#application-splash {',
			'    position: absolute;',
			'    top: 35%;',
			'    width: 50%;',
			'    left: 25%;',
			'}',

			'#application-splash img {',
			'    width: 100%;',
			'}',

			'#progress-bar-container {',
			'    margin: 20px auto 0 auto;',
			'    height: 2px;',
			'    width: 100%;',
			'    background-color: #ce1126;',
			'}',

			'#progress-bar {',
			'    width: 0%;',
			'    height: 100%;',
			'    background-color: #000;',
			'}',
			'@media (max-width: 480px) {',
			'    #application-splash {',
			'        width: 170px;',
			'        left: calc(50% - 85px);',
			'    }',
			'}'
		].join("\n");

		var style = document.createElement('style');
		style.type = 'text/css';
		if (style.styleSheet) {
		style.styleSheet.cssText = css;
		} else {
		style.appendChild(document.createTextNode(css));
		}

		document.head.appendChild(style);
	}

}